module.exports = __webpack_public_path__ + "static/media/check.ac60cb5a.png";